export type LiveUpdate = {
  version: number
  [key: string]: unknown
}

function isLiveUpdate(record: unknown): record is LiveUpdate {
  return typeof record === "object" && record !== null && "version" in record
}

export function updateRecord<
  T extends LiveUpdate | null | undefined,
  R extends LiveUpdate,
>(record: T, update: R) {
  if (!record) {
    return { ...record, ...update }
  }

  const newer = isNewer(record, update)
  let changed = false

  for (const key in update) {
    const recordValue = record[key]
    const updateValue = update[key]

    if (isLiveUpdate(recordValue) && isLiveUpdate(updateValue)) {
      record[key] = updateRecord(recordValue, updateValue)
      changed = changed || record[key] !== recordValue
    } else if (newer && recordValue !== updateValue) {
      record[key] = updateValue
      changed = true
    }
  }

  return changed ? { ...record } : record
}

export function isNewer(current: LiveUpdate, update: LiveUpdate): boolean {
  return update.version >= current.version
}
